import { FETCH_ALL_SUPPLIERS, FETCH_PAGINATE_SUPPLIERS, FETCH_CURRENT_SUPPLIER } from './../../mutation-types';

export default {
  [FETCH_ALL_SUPPLIERS](state, suppliers) {
    state.all = suppliers;
  },

  [FETCH_PAGINATE_SUPPLIERS](state, { suppliers, pagination }) {
    state.items = suppliers;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_SUPPLIER](state, supplier) {
    state.currentSupplier = supplier;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/supplier/mutations.js